import SocialProof from '../ckan/SocialProof';
import Features from './Features';
import Blog from '../ckan/Blog';
import Hero from '../ckan/Hero';
import Highlight from '../ckan/Highlight'
import ValuePropositions from '../ckan/ValuePropositions'
import HowItWorks from './HowItWorks'
import Link from 'next/link';

export default function Idm({ blogs }) {
  const values = [
    {
      title: "Integrate diverse data",
      text: "Pull in data from internal and external systems via APIs to display data in a central repository.",
    },
    {
      title: "Enhance data quality",
      text: "Get quality data by providing metadata, pulling in contextual data, and running data validation processes.",
    },
    {
      title: "Create new value from data",
      text: "With visualization and analysis tools, you can start using data to find answers, build products and shape policy.",
    },
  ]

  const featured = [
    {
      title: "Data Integration",
      text: "Combine and harmonize data from various sources, creating a consistent and accessible view for better access, analysis, and decision-making.",
      icon: "/assets/icons/hexagonal.json",
    },
    {
      title: "Data Governance & Compliance",
      text: "Stay confident in your data's quality, consistency, and regulatory compliance.",
      icon: "/assets/icons/privacy-policy.json",
    },
    {
      title: "Catalog and Metadata Management",
      text: "With a central data catalog and customizable metadata, you can browse your data assets with ease.",
      icon: "/assets/icons/data-catalog.json",
    },
    {
      title: "Data Storage",
      text: "Whether it's data or metadata, raw bulk or structured, in the cloud or on-premise, a data API lets you store data.",
      icon: "/assets/icons/server-1.json",
    },
    {
      title: "Visualizations & Dashboards",
      text: "Transform complex data into easily digestible graphs, tables, and visuals, so that you and others can understand your data at a glance.",
      icon: "/assets/icons/presentation-1.json",
    },
    {
      title: "Permissions & Access Control",
      text: "Keep sensitive data safe with custom access permissions that allow you to share securely across different teams and organizations.",
      icon: "/assets/icons/padlock.json",
    },
    {
      title: "Data Exploration and Discovery",
      text: "Powerful data APIs and previewing tools let you explore data stored in the system and discover datasets via search and taxonomies.",
      icon: "/assets/icons/analytical-skill.json",
    },
    {
      title: "Continuous Support & Partnership",
      text: "Keep your data management processes optimized with our ongoing support, resources, and partnership, ensuring sustainable growth and success.",
      icon: "/assets/icons/support.json",
    },
  ]

  return (
    <section className="bg-homeExpert bg-no-repeat bypass-filter bg-idmPosition !overflow-x-hidden">

      <section>
        <Hero topTitle="Internal Data Management" title="A management framework for your data. Create systems to help your data flow." subtitle="A good data management system helps your teams locate, store, secure, share, and version your data. Your data needs, sorted." ctaOffer="See other offerings" ctaUrl="/solutions#offerings" />
      </section>

      <section className='pt-8'>
        <SocialProof />
      </section>

      <section className='relative w-screen max-w-screen overflow-hidden lg:flex-row bg-gradient-to-b from-transparent to-[#F7F8F9]'>
          <Highlight subtitle="MASTER YOUR DATA" topTitle="What is data management?"
            text="Data management is a broad term that describes the process of collecting, cataloging, and processing data within an organization to achieve a certain outcome. This may be to publish data openly so that others may use it, or to process data internally in such a way as to generate insight."
           />
           <Highlight subtitle="HARNESS THE POWER OF DATA" topTitle="What&apos;s a data management system (DMS)?"
            text="Organizations worldwide are adopting data management systems to advance their organization&apos;s cause through data, whether that be publishing open data or managing data internally. By simplifying complex data processes, data management systems are turning data management into an everyday activity for non-technical staff across all levels of government, enterprise, and nonprofits."
            reverse
           />
      </section>

      <section>
      <ValuePropositions topTitle="Maximize your data potential" title="Our expertise and advanced tools will help you overcome the complexity of data management, transform disorganized data into actionable insights, and unleash the true potential of your organization." valuePropositions={values} />
      </section>

      <section className='mt-16'>
       <Features topTitle="Your data, your way " title="Our suite of powerful features is designed to help you get more value from your data. Seamlessly integrate, govern, and visualize your data with customizable metadata, secure access controls, powerful data exploration tools, and more. Experience our user-friendly data management platform that ensures data quality and security across your organization.
" featuredItems={featured}/>
      </section>

      <section>
        <HowItWorks />
      </section>

      <section className='bg-[#F7F8F9] py-20 relative w-screen max-w-screen overflow-hidden' tabindex={0}>
        <h3 className='text-center mx-auto medium-title font-["Inter"]'>Data Management is complex. We make it easy.</h3>
        <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>Get the answers you need today. Join thousands of happy customers.</p>
        <div className='flex flex-col  sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
         <div className='btn-primary'><Link href="/contact">Email us</Link></div>
        <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
        </div>
      </section>
      <section>
        <Blog blogs={blogs} catalog="Data Management" />
      </section>
    </section >
  );
}
